import { render, staticRenderFns } from "./ProductLink.vue?vue&type=template&id=2fb94569"
import script from "./ProductLink.vue?vue&type=script&lang=ts"
export * from "./ProductLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports